/**
 * @generated SignedSource<<b221f13f9dad3350e8ed4faf7b2c3f0c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type statusFieldValueLabel_softwareFiltersPopup$data = {
  readonly displayName: string;
  readonly statusCategory: {
    readonly statusCategoryId: string;
  };
  readonly " $fragmentType": "statusFieldValueLabel_softwareFiltersPopup";
};
export type statusFieldValueLabel_softwareFiltersPopup$key = {
  readonly " $data"?: statusFieldValueLabel_softwareFiltersPopup$data;
  readonly " $fragmentSpreads": FragmentRefs<"statusFieldValueLabel_softwareFiltersPopup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "statusFieldValueLabel_softwareFiltersPopup",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraStatusCategory",
      "kind": "LinkedField",
      "name": "statusCategory",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCategoryId"
        }
      ]
    }
  ],
  "type": "JiraJqlStatusFieldValue"
};

(node as any).hash = "fc08a83abe5a56d28243e1b573e4e7f1";

export default node;
